import { initialPagination } from '@app/constants/pagination';

export const tableDataInit = {
  data: [],
  pagination: initialPagination,
  filterOptions: {
    fishers: [],
    inspectors: [],
    licenses: [],
    waterbodies: [],
    organizationalEntities: [],
    employees: [],
    type: [],
    status: [],
  },
  loading: false,
  error: false,
};

export const summaryDataInit = {
  loading: true,
  error: false,
  data: {
    inspections: 0,
    penalties: 0,
    waterbodies: 0,
  },
};

export const downloadDataInit = {
  data: [],
  loading: false,
};
